import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Keyframes, Frame } from 'react-keyframes';

// const zeroPad = (num, places) => String(num).padStart(places, '0');
// const frames = [...Array(21).keys()];
const useStyles = makeStyles({
  bubble: {
    alignItems: 'center',
    backgroundImage: `url('images/quiz/cheerup_bubble.png')`,
    display: 'flex',
    fontSize: '2rem',
    justifyContent: 'center',
    height: 73,
    marginBottom: 0,
    position: 'absolute',
    visibility: ({ showBubble }) => (showBubble ? 'visible' : 'hidden'),
    width: 96,
  },
  character: {
    display: 'flex',
    marginLeft: 70,
  },
  root: {},
});

const CheerGirl = ({ loop, onEnd, ...rest }) => {
  const [showBubble, setShowBubble] = useState(false);
  const { bubble, character } = useStyles({ showBubble });
  const timer1 = useRef();
  const timer2 = useRef();
  useEffect(() => {
    timer1.current = setTimeout(() => setShowBubble(true), 400);
    timer2.current = setTimeout(() => setShowBubble(false), 3200);
    return () => {
      clearTimeout(timer1.current);
      clearTimeout(timer2.current);
    }
  }, []);

  return (
    <div {...rest}>
      <div className={bubble}>เก่งมาก</div>
      <Keyframes
        className={character}
        component={'div'}
        loop={loop}
        onEnd={onEnd}
      >
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00000.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00001.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00002.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00003.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00004.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00005.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00006.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00007.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00008.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00009.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00010.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00011.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00012.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00013.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00014.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00015.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00016.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00017.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00018.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00019.png`} alt="" />
        </Frame>
        <Frame duration={200}>
          <img src={`images/quiz/cheerup_00020.png`} alt="" />
        </Frame>
      </Keyframes>
    </div>
  );
};

export default CheerGirl;
